import axios from 'axios';
import { toast } from 'react-toastify';
import data from '../config/connData';
import {store} from '../redux'
import { logout } from '../redux/actions/login';

const instance=  axios.create({
    // El backend .NET monta las rutas en la raíz (sin prefijo de ambiente como el Express
    // anterior, que montaba todo bajo /${NODE_ENV}) — no agregar ese segmento acá.
    baseURL:`${data.BACKEND_URL_PROTOCOL}://${data.BACKEND_URL}:${data.BACKEND_URL_PORT}`,
});


instance.interceptors.request.use(async (config) => {

    const token = await store.getState().login.token;
    if (token) {
        const { headers } = config;
        headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

export const handleResponseSuccess = (response) => response;

// 401 = la sesión de GERA fue revalidada en el backend y ya no es válida (expiró, o GERA la
// invalidó) — ver GeraAuthenticationHandler. Antes esto fallaba en silencio (el componente que
// hizo el pedido solo lo veía como un error genérico en la consola); acá se limpia la sesión
// local y se avisa, para no dejar al usuario mirando una pantalla que nunca va a cargar datos.
// Se excluyen /auth/signin (401 ahí es "usuario o contraseña incorrectos", no sesión expirada)
// y /auth/signout (evita loop: el propio logout llama a signout, que puede 401 con un token ya
// vencido — el saga de logout ya maneja esa falla con su try/catch).
export const handleResponseError = (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || '';
    const isAuthEndpoint = url.includes('/auth/signin') || url.includes('/auth/signout');

    if (status === 401 && !isAuthEndpoint) {
        toast.error('Tu sesión expiró. Iniciá sesión de nuevo.');
        store.dispatch(logout());
    }

    return Promise.reject(error);
};

instance.interceptors.response.use(handleResponseSuccess, handleResponseError);

export default instance;